import React, { useEffect, useState } from 'react'
import { MaterialReactTable, createMRTColumnHelper, useMaterialReactTable, } from 'material-react-table';
import EvnVar from '../../../../EnvVar'
import axios from 'axios'
import Cookies from 'js-cookie'
import { Box, Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';

function TestimonialsActivity() {
    const baseURL = EvnVar()
    const token = Cookies.get("jwt")
    const [data, setData] = useState([])

    useEffect(() => {
        (async () => {
            try {
                const config = {
                    method: "get",
                    maxBodyLength: Infinity,
                    url: `${baseURL}/user/testimonial`,
                    headers: {
                        Authorization: token,
                    },
                    withCredentials: true,
                };

                const response = await axios.request(config);
                let completeResponse = response.data.testimonial
                completeResponse = completeResponse.map(item => {
                    const { ambassador, ...rest } = item;
                    return {
                        ...rest,
                        fullname: ambassador.fullname,
                        phone: ambassador.phone
                    }
                })
                // setTestimonialData(completeResponse);
                setData(completeResponse)
                console.log("Get Testimonials =>", completeResponse);
            } catch (error) {
                console.log("Error fetching Testimonials:", error);
            }
        })()
    }, []);

    const columnHelper = createMRTColumnHelper();

    const columns = [
        columnHelper.accessor('ambassador_id', {
            header: 'Id',
            size: "10"
        }),
        columnHelper.accessor('fullname', {
            header: 'Ambassador Name',
        }),
        columnHelper.accessor('phone', {
            header: 'Phone Number',
        }),
        columnHelper.accessor('testimonial_text', {
            header: 'Testimonial',
        }),
    ]

    const csvConfig = mkConfig({
        fieldSeparator: ',',
        decimalSeparator: '.',
        useKeysAsHeaders: true,
    });

    const handleExportRows = (rows) => {
        let rowData = rows.map((row) => row.original);
        console.log('rowDAtea ', rowData)
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
    };

    const handleExportData = () => {
        console.log('data is ', data)
        const csv = generateCsv(csvConfig)(data);
        download(csvConfig)(csv);
    };


    const table = useMaterialReactTable({
        columns,
        data, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        enableRowSelection: true,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Button
                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Data
                </Button>
                <Button
                    disabled={table.getPrePaginationRowModel().rows.length === 0}
                    //export all rows, including from the next page, (still respects filtering and sorting)
                    onClick={() =>
                        handleExportRows(table.getPrePaginationRowModel().rows)
                    }
                    startIcon={<FileDownloadIcon />}
                >
                    Export All Rows
                </Button>


                <Button
                    disabled={table.getRowModel().rows.length === 0}
                    //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
                    onClick={() => handleExportRows(table.getRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Page Rows
                </Button>
                <Button
                    disabled={
                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                    startIcon={<FileDownloadIcon />}
                >
                    Export Selected Rows
                </Button>
            </Box>
        ),
    });
    return (
        <>
            <div className="table-data">
                <h2 className='subheading'>Testimonials</h2>
                <MaterialReactTable table={table} />
            </div>
        </>
    )
}

export default TestimonialsActivity
